import { Api } from '../api';
import { customers } from '../endpoints';
import type { ApplicationCustomerDetailsEntity, CustomerDataItem, CustomerEntity, CustomerSearchParams } from './models';

export class CustomerApi extends Api {
  static getCustomers = (searchParams: CustomerSearchParams = {}, signal?: AbortSignal) =>
    this.post<CustomerDataItem[]>(customers.getCustomers(), searchParams, { signal });

  static getCustomer = (customerId: string, signal?: AbortSignal) => this.get<CustomerEntity>(customers.getCustomerCard(customerId), { signal });

  static getCustomerApplicationDetails = (customerId: string, signal?: AbortSignal) =>
    this.get<ApplicationCustomerDetailsEntity>(customers.getCustomerCard(customerId), { signal });
}
